import { useEffect, useState } from "react";
import axios from '../helpers/axios';

export const createNewWorkFlow = async (values, callback) => {
    const res = await axios.post(`/workflow/creaetworkflow`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const updateWorkFlow = async (id, values, callback) => {
    const res = await axios.put(`/workflow/updateworkflow/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const deleteWorkflow = async (id, values, callback) => {
    const res = await axios.put(`/workflow/deleteworkflow/${id}`, values);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const getAllWorkflows = async (rowPerPage, pageNumber, search, callback) => {
    const res = await axios.get(`/workflow/?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}&search=${search}`);

    if (res.status === 200) {
        const workflowList = res.data.response;
        callback(workflowList);
    } else {
        callback(res.data.response);
    }
}

export const getWorkflowById = async (id, callback) => {
    await axios.get(`/workflow/${id}`).then(res => {
        if (res.status === 200) {
            callback(res.data.response.data);
        } else {
            callback(res.data.response.data);
        }
    })
}

export const getWorkflowsByDateRange = async (rowPerPage, pageNumber, startDate, endDate, callback) => {
    const res = await axios.get(`/workflow/bybetweendateworkflow/${startDate}&${endDate}?rowPerPage=${rowPerPage}&pageNumber=${pageNumber}`);

    if (res.status === 200) {
        callback(res.data.response);
    } else {
        callback(res.data.response);
    }
}

export const WorkFlowAPI = () => {
    const [workflows, setWorkflows] = useState([]);
    const [workflowDetail, setWorkflowDetail] = useState({});

    const [rowPerPage, setRowPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [callback, setCallback] = useState(false);
    const [id, setId] = useState(0);

    useEffect(() => {
        getAllWorkflows(rowPerPage, pageNumber, search, res => {
            setWorkflows(res);
            setTotalPages(res.totalPages || 1);
        })

        getWorkflowById(id, res => {
            setWorkflowDetail(res)
        })
    }, [callback, rowPerPage, search, pageNumber, id]);

    return {
        workflows: [workflows, setWorkflows],
        workflowDetail: [workflowDetail, setWorkflowDetail],
        id: [id, setId],
        rowPerPage: [rowPerPage, setRowPerPage],
        search: [setSearch],
        pageNumber: [pageNumber, setPageNumber],
        totalPages: [totalPages, setTotalPages],
        callback: [callback, setCallback]
    }
}